var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var CopyIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 10,
    glyphHeight: 13
  }), React.createElement("path", {
    d: "M0.901493 2.27609L0.899811 3.5496V9.8508C0.899811 10.9275 1.77267 11.8004 2.8494 11.8004L8.01809 11.8005C7.83276 12.3247 7.33284 12.7002 6.74522 12.7002H2.8494C1.27572 12.7002 0 11.4245 0 9.8508V3.5496C0 2.96129 0.376388 2.4609 0.901493 2.27609ZM8.24826 0.700195C8.99369 0.700195 9.59798 1.30448 9.59798 2.04991V9.84827C9.59798 10.5937 8.99369 11.198 8.24826 11.198H2.8494C2.10397 11.198 1.49968 10.5937 1.49968 9.84827V2.04991C1.49968 1.30448 2.10397 0.700195 2.8494 0.700195H8.24826ZM8.24826 1.60001H2.8494C2.60092 1.60001 2.3995 1.80144 2.3995 2.04991V9.84827C2.3995 10.0967 2.60092 10.2982 2.8494 10.2982H8.24826C8.49674 10.2982 8.69817 10.0967 8.69817 9.84827V2.04991C8.69817 1.80144 8.49674 1.60001 8.24826 1.60001Z",
    fill: "#5A5A5A"
  }));
};
export var CopyIconGlyph = function (props) {
  return React.createElement(CopyIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};